// --------------------------------------------------------------------------------------------------------------------
// <copyright file="SolverAlgorithm.cs" company="Microsoft">
//  (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// MSAGL class for algorithm enumeration for Projection Solver.
// --------------------------------------------------------------------------------------------------------------------
export var SolverAlgorithm;
(function (SolverAlgorithm) {
    // Iterative Project/Split only.
    SolverAlgorithm[SolverAlgorithm["ProjectOnly"] = 0] = "ProjectOnly";
    // Diagonally-scaled gradient projection/Qpsc (Quadratic Programming for Separation Constraints).
    SolverAlgorithm[SolverAlgorithm["QpscWithScaling"] = 1] = "QpscWithScaling";
    // Gradient projection/Qpsc (Quadratic Programming for Separation Constraints) without diagonal scaling.
    SolverAlgorithm[SolverAlgorithm["QpscWithoutScaling"] = 2] = "QpscWithoutScaling";
})(SolverAlgorithm || (SolverAlgorithm = {}));
//# sourceMappingURL=SolverAlgorithm.js.map